import { createFileRoute } from "@tanstack/react-router"

import { seoMeta } from "@/lib/seo"

import { ThanksContent } from "./-components/ThanksContent"

export const Route = createFileRoute("/_content/rebellion/thanks")({
  head: () => {
    const baseMeta = seoMeta({
      title: "Thanks for joining the rebellion",
      description: "You're on the list. Check your inbox for a confirmation.",
      url: "https://entire.com/rebellion/thanks",
    })
    return {
      ...baseMeta,
      meta: baseMeta.meta.map((entry) =>
        entry["name"] === "robots" ? { name: "robots", content: "noindex, follow" } : entry,
      ),
    }
  },
  component: ThanksContent,
})
